import { memo, useMemo } from "react";
import type { CablePathsLayerProps } from "./types";

export const CablePathsLayer = memo(function CablePathsLayer({
  cablePaths,
}: CablePathsLayerProps) {
  const nodeMap = useMemo(() => {
    const map = new Map<number, { x: number; y: number }>();
    for (const n of cablePaths.nodes) {
      map.set(n.id, { x: parseFloat(n.x), y: parseFloat(n.y) });
    }
    return map;
  }, [cablePaths.nodes]);

  return (
    <>
      {cablePaths.edges.map((edge) => {
        const from = nodeMap.get(edge.fromNodeId);
        const to = nodeMap.get(edge.toNodeId);
        if (!from || !to) return null;

        return (
          <line
            key={edge.id}
            x1={from.x}
            y1={from.y}
            x2={to.x}
            y2={to.y}
            stroke="#3b82f6"
            strokeWidth={16}
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={0.7}
            vectorEffect="non-scaling-stroke"
          />
        );
      })}
    </>
  );
});
